import {call, put, takeLatest, select} from 'redux-saga/effects'
import {initialize} from 'redux-form'
import i18n from '../../i18n'
import {downloadDocument} from '../../util/util'
import actionTypes from '../../constants/actions/importarPedidosExcel/importarPedidosExcel'
import {submitImportarPedidosExcelSuccess} from '../../actions/importarPedidosExcel/importarPedidosExcel'
import {openModal, closeModal, openSimpleModal, openMensajeAlerta} from '../../actions/common'
import { yesNoModal } from '../modal/yesNoModal'
import getImportarPedidosExcel from '../../services/importarPedidosExcel/getImportarPedidosExcel'
import getDescargarPlantillaExcelPedidosExcel from '../../services/importarPedidosExcel/getDescargarPlantillaExcelPedidosExcel'

export function * submitImportarPedidosExcel ({value}) {
  try {
    let auth = yield select(state => state.auth)
    const listCargaIndex = yield call(getImportarPedidosExcel, value, auth.token)    
    yield put(submitImportarPedidosExcelSuccess(listCargaIndex))
  } catch (error) {
    console.log(error)
  } finally {
    /*yield put(commonActions.hideLoader())*/
  }
}
export function * watchSubmitImportarPedidosExcel () {
  yield takeLatest(actionTypes.SUBMIT_IMPORTAR_PEDIDOS_EXCEL, submitImportarPedidosExcel)
}

export function * descargarPlantillaExcelPedidosExcel () {
  try {
    const archivoExcel = yield call(getDescargarPlantillaExcelPedidosExcel, null)
    let href = 'data:application/csv;base64,' + encodeURIComponent(archivoExcel.xls)
    let name = i18n.t('IMPORTAR_PEDIDOS_EXCEL.EJEMPLO_EXCEL_PEDIDOS') + ".xlsx"
    downloadDocument(href, name)
  } catch (error) {
    console.log(error)
  } finally {
  }
}
export function * watchDescargarPlantillaExcelPedidosExcel () {
  yield takeLatest(actionTypes.DESCARGAR_PLANTILLA_EXCEL_PEDIDOS_EXCEL, descargarPlantillaExcelPedidosExcel)
}